/**
 *
 *
 * @author Shigq
 * @date 2021/11/17 18:36
 */
import { plugins } from '@libs/ui'

export default app => {
  plugins.elementPlus.install(app, {
    // 按需引入icon
    icons: ['UserFilled', 'Delete', 'Plus', 'ZoomIn', 'CaretBottom', 'InfoFilled', 'View', 'Remove', 'Hide','Search','CircleCheck','CirclePlus','Warning', 'Upload', 'Edit']
  })
}
